import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { captureAcquisitionFirstTouch, captureReferral } from './services/acquisition'

// Content protection — single named handlers, removable and non-duplicable
function __mqProtectContext(e) {
  if (__mqIsAllowed(e.target)) return
  e.preventDefault()
}
function __mqProtectCopy(e) {
  if (__mqIsAllowed(e.target)) return
  e.preventDefault()
}
function __mqProtectSelect(e) {
  if (__mqIsAllowed(e.target)) return
  document.getSelection()?.removeAllRanges()
}
function __mqIsAllowed(el) {
  try {
    const u = JSON.parse(localStorage.getItem('monquiz_user') || 'null')
    if (u && (u.role === 'admin' || u.role === 'reviewer')) return true
  } catch {}
  if (!el) return false
  if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') return true
  if (el.isContentEditable) return true
  if (el.closest && el.closest('[contenteditable]')) return true
  return false
}
// Remove first to avoid duplicates, then add
document.removeEventListener('contextmenu', __mqProtectContext)
document.removeEventListener('copy', __mqProtectCopy)
document.removeEventListener('selectstart', __mqProtectSelect)
document.addEventListener('contextmenu', __mqProtectContext)
document.addEventListener('copy', __mqProtectCopy)
document.addEventListener('selectstart', __mqProtectSelect)

// First-touch acquisition capture (utm_* + referrer) for signup attribution.
captureAcquisitionFirstTouch()
captureReferral()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
